module.exports = __webpack_public_path__ + "img/music-note-02.60ff59c0.svg";